<template>
  <a-card :bordered='false' class='p-b-80'>
    <div class='width80 s_mauto'>
       <h3 class='text-ac s_c333 m-b-30 s_font_b'>温馨提醒您，您有【待发货】订单，点击查看</h3>
    <div class="main s_c333 m-b-100 text-ac width70 s_mauto">
      温馨提醒您，您有【待发货】订单，点击查看详情！温馨提醒您，您有【待发货】订单，点击查看详情！
      温馨提醒您，您有【待发货】订单，点击查看详情！温馨提醒您，您有【待发货】订单，点击查看详情！
      温馨提醒您，您有【待发货】订单，点击查看详情！温馨提醒您，您有【待发货】订单，点击查看详情！
      温馨提醒您，您有【待发货】订单，点击查看详情！温馨提醒您，您有【待发货】订单，点击查看详情！
      温馨提醒您，您有【待发货】订单，点击查看详情！
    </div>
    <div class="time text-ar s_c8e">2020-06-10 00:00:00</div>
    </div>
  </a-card>
</template> 